<template>
  <v-container id="cargo" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="light-blue" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/cargo/create'">
            <v-list-item-title>{{ $i18n.t("Create") }}</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <z-confirm-button
              class="float-right list-item-btn"
              color="black"
              small
              text
              dark
              :message="$i18n.t('Do you want to delete this Cargo ?')"
              @click="deleteCargo(null)"
            >Delete</z-confirm-button>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="light-blue"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn color="black" class="mr-0" fab small text @click="showFilter = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" md="2">
              <z-client-select v-model="filters.client_id" />
            </v-col>

            <v-col cols="12" md="2">
              <z-country-select v-model="filters.country"></z-country-select>
            </v-col>

            <v-col cols="12" md="2">
              <z-city-select v-model="filters.city" :country="filters.country"></z-city-select>
            </v-col>

            <v-col cols="12" md="2" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right:10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width:100%"
      :loading="loading"
    >{{ $i18n.t("No records available") }}</v-btn>

    <base-material-card
      icon="mdi-domain"
      :title="$i18n.t('Cargo')"
      class="px-5 py-3"
      v-if="grid.records"
    >
      <z-grid-record :grid="grid" />

      <v-card class="py-0 my-2" elevation="1" color="blue lighten-5 d-none d-md-flex">
        <v-card-text class="py-0">
          <v-row>
            <v-row>
              <v-col cols="12" md="1">{{ $i18n.t("Date") }}</v-col>
              <v-col cols="12" md="1">{{ $i18n.t("Client") }}</v-col>
              <v-col cols="12" md="1">{{ $i18n.t("Load") }}</v-col>
              <v-col cols="12" md="1">{{ $i18n.t("Material") }}</v-col>
              <v-col cols="12" md="1">{{ $i18n.t("Truck Type") }}</v-col>
              <v-col cols="12" md="1">{{ $i18n.t("Weight") }}</v-col>
              <v-col cols="12" md="2">{{ $i18n.t("Origin") }}</v-col>
              <v-col cols="12" md="2">{{ $i18n.t("Destination") }}</v-col>
              <v-col cols="12" md="2">{{ $i18n.t("Action") }}</v-col>
            </v-row>
          </v-row>
        </v-card-text>
      </v-card>

      <div v-for="cargo in grid.rows" :key="cargo._id" class="py-0 my-2 mt-0 mb-0" elevation="1">
        <cargo-row :value="cargo" @deleteCargo="deleteCargo" />
      </div>

      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>

    <v-dialog v-model="showBidDetail" transition="dialog-top-transition" width="900">
      <v-card v-if="quotDetail">
        <v-toolbar dark color="primary" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-chat</v-icon>
            {{ $i18n.t("View Bids") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="showBidDetail = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <span>{{ $i18n.t("Wish Price") }}</span>
            </v-col>
            <v-col cols="12" md="6">
              <span>
                {{
                quotDetail.quotRequest ? quotDetail.quotRequest.wishPrice : ""
                }}
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-card>
                <v-list-item-content calss="px-3">
                  <v-row>
                    <v-col cols="12" md="4" class="mx-3">
                      <h3>{{ $i18n.t("Bids") }}</h3>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-simple-table dense style="padding: 10px">
                  <thead>
                    <tr>
                      <th class="primary--text">{{ $i18n.t("Supplier") }}</th>
                      <th class="primary--text">{{ $i18n.t("Bid Price") }}</th>
                      <th class="primary--text">{{ $i18n.t("Status") }}</th>
                      <th class="text-right primary--text">{{ $i18n.t("Action") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(bid, index) in quotDetail.bids" :key="'bid' + index">
                      <td>
                        <span>{{ bid.vendorName }}</span>
                      </td>
                      <td>
                        <span>{{ bid.fare ? bid.fare.total : "" }}</span>
                      </td>
                      <td>
                        <span>{{ bid.statusStr }}</span>
                      </td>
                      <td>
                        <z-confirm-button
                          class="float-right"
                          color="success"
                          small
                          fab
                          dark
                          :message="$i18n.t('Do you want to accept this bid ?')"
                          @click="acceptBid(bid)"
                        >
                          <v-icon>mdi-check</v-icon>
                        </z-confirm-button>
                      </td>
                    </tr>
                    <v-spacer></v-spacer>
                  </tbody>
                </v-simple-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import CargoRow from "@/views/cargo/CargoRow.vue";

@Component({
  components: { CargoRow },
})
export default class Cargo extends Vue {
  grid = { page: 0 };
  rows = 20;
  url = "/api/cargo/grid?rows=" + this.rows;
  showFilter = false;
  name = "";
  menu1 = false;
  code = "";
  filterUrl = "";
  country = "";
  city = "";
  on = null;
  page = 1;
  filters = {
    client_id: "",
    country: "",
    city: "",
  };
  showBidDetail = false;
  quotDetail = null;

  get loading() {
    return common.loading;
  }

  async acceptBid(bid) {
    try {
      common.setLoading(true);
      this.quotDetail = await doGet("/api/quot/bid/" + bid._id + "/accept");
      common.setLoading(false);
      this.showBidDetail = true;
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  // async showBids(cargo) {
  //   try {
  //     common.setLoading(true);
  //     this.quotDetail = await doGet(
  //       "/api/quot/bid/cargo/" + cargo._id + "/detail"
  //     );
  //     common.setLoading(false);
  //     this.showBidDetail = true;
  //   } catch (e) {
  //     common.setLoading(false);
  //     common.setError(e.message);
  //   }
  // }

  async mounted() {
    common.setLoading(true);
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.filters = {};
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.filters.client_id)
      this.filterUrl += "&name=" + this.filters.client_id;
    if (this.filters.country)
      this.filterUrl += "&address.country=" + this.filters.country;
    if (this.filters.city)
      this.filterUrl += "&address.city=" + this.filters.city;
    common.setLoading(true);
    await this.showPage(1);
  }

  async deleteCargo(cargo) {
    common.setLoading(true);
    try {
      await doGet("/api/cargo/" + cargo._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.btn-list-item {
  padding: 0;
  float: left !important;
}
.btn-list-item .v-btn--text {
  padding: 0;
  text-transform: none;
  font-size: 14px;
  float: left;
  margin: 0;
}
</style>
